var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"network-withdraw-wrap"},[_c('NetworkWithdrawCpt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }